import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings -> Easeedesk -> External service providers (v4/api, `App\Settings\
 * Easeedesk\EaseedeskExternalProviders`). Forma tabelului e inghetata in
 * `settings/easeedesk/__fixtures__/externalProvidersTable.json`.
 */
const BASE = '/settings/easeedesk/external_service_providers'

export interface ExternalProvider {
  ID: number
  name: string
  email: string
  phone: string
}

export interface ExternalProvidersTableRequest {
  draw: number
  start: number
  length: number
  orderColumn: number
  orderName: string
  orderDir: 'asc' | 'desc'
  search: string
}

export interface ExternalProvidersTablePage {
  draw: number
  recordsTotal: number
  recordsFiltered: number
  data: (ExternalProvider & { DT_RowId: string })[]
}

export function externalProvidersTableQuery(r: ExternalProvidersTableRequest) {
  const p = new URLSearchParams()
  p.set('draw', String(r.draw))
  p.set('start', String(r.start))
  p.set('length', String(r.length))
  p.set('order[0][column]', String(r.orderColumn))
  p.set('order[0][dir]', r.orderDir)
  p.set(`columns[${r.orderColumn}][name]`, r.orderName)
  p.set('search[value]', r.search)
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'external_providers', 'table', r],
    queryFn: () => apiGet<ExternalProvidersTablePage>(`${BASE}/table?${p.toString()}`),
  })
}

export function externalProviderQuery(id: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'external_providers', 'one', id],
    queryFn: () => apiGet<ExternalProvider>(`${BASE}/${id}`),
    enabled: id > 0,
  })
}

export interface ExternalProviderFields {
  provider_name: string
  provider_email: string
  provider_phone: string
}

/** `Easeedesk::create_external_provider`. */
export function createExternalProvider(fields: ExternalProviderFields) {
  return apiPost<{ status: string; ID: number }>(BASE, { ...fields })
}

/** `Easeedesk::save_external_provider`. */
export function saveExternalProvider(id: number, fields: ExternalProviderFields) {
  return apiPost<{ status: string; ID: number }>(`${BASE}/${id}`, { ...fields })
}

/** `Easeedesk::remove_external_provider`. */
export function removeExternalProvider(id: number) {
  return apiPost<{ status: string; ID: number }>(`${BASE}/${id}/remove`, {})
}
